import { Trans, useLingui } from "@lingui/react/macro";
import { OutlinedButton } from "@medoma/components/Button/Button";
import { Heading } from "@medoma/components/Heading/Heading";
import { Text } from "@medoma/components/Text/Text";
import { humanFormat } from "@medoma/models/date-and-time";
import {
  canDischargePatient,
  getStatusTimestamp,
  patientStatusDictionary,
  type IExistingPatient,
} from "@medoma/models/patients";
import { useParentRoutesPatient } from "@/api/Patients";
import styles from "./CareEpisode.module.scss";

export const CareEpisode = ({ patient }: { patient: IExistingPatient }) => {
  const { t } = useLingui();
  const statusTimestamp = getStatusTimestamp(patient);

  return (
    <section className={styles.careEpisode}>
      <Heading level="h2">
        <Trans>Vårdperiod</Trans>
      </Heading>
      <div className={styles.statusAndTimestamp}>
        <Text element="span" weight="bold">
          {t(patientStatusDictionary[patient.status].singular)}
        </Text>
        {statusTimestamp ? (
          <Text element="span">
            {humanFormat(statusTimestamp, {
              dateStyle: "medium",
              timeStyle: "short",
            })}
          </Text>
        ) : null}
      </div>
      {canDischargePatient(patient) ? (
        <OutlinedButton asLinkTo="discharge">
          <Trans>Skriv ut</Trans>
        </OutlinedButton>
      ) : null}
    </section>
  );
};

export const CareEpisodeParentRoutesPatient = () => (
  <CareEpisode patient={useParentRoutesPatient()} />
);
